"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scanner = void 0;
const Token_1 = require("./Token");
const ROW_DELIMITER = /((?:\r\n)|\n|\r)/;
class Scanner {
  line;
  parserOptions;
  lineLength;
  hasMoreData;
  cursor = 0;
  constructor(args) {
    this.line = args.line;
    this.lineLength = this.line.length;
    this.parserOptions = args.parserOptions;
    this.hasMoreData = args.hasMoreData;
    this.cursor = args.cursor || 0;
  }
  get hasMoreCharacters() {
    return this.lineLength > this.cursor;
  }
  get nextNonSpaceToken() {
    const {
      lineFromCursor
    } = this;
    const regex = this.parserOptions.NEXT_TOKEN_REGEXP;
    if (lineFromCursor.search(regex) === -1) {
      return null;
    }
    const match = regex.exec(lineFromCursor);
    if (match == null) {
      return null;
    }
    const token = match[1];
    const startCursor = this.cursor + (match.index || 0);
    return new Token_1.Token({
      token,
      startCursor,
      endCursor: startCursor + token.length - 1
    });
  }
  get nextCharacterToken() {
    const {
      cursor,
      lineLength
    } = this;
    if (lineLength <= cursor) {
      return null;
    }
    return new Token_1.Token({
      token: this.line[cursor],
      startCursor: cursor,
      endCursor: cursor
    });
  }
  get lineFromCursor() {
    return this.line.substr(this.cursor);
  }
  advancePastLine() {
    const match = ROW_DELIMITER.exec(this.lineFromCursor);
    if (!match) {
      if (this.hasMoreData) {
        return null;
      }
      this.cursor = this.lineLength;
      return this;
    }
    this.cursor += (match.index || 0) + match[0].length;
    return this;
  }
  advanceTo(cursor) {
    this.cursor = cursor;
    return this;
  }
  advanceToToken(token) {
    this.cursor = token.startCursor;
    return this;
  }
  advancePastToken(token) {
    this.cursor = token.endCursor + 1;
    return this;
  }
  truncateToCursor() {
    this.line = this.lineFromCursor;
    this.lineLength = this.line.length;
    this.cursor = 0;
    return this;
  }
}
exports.Scanner = Scanner;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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